import { Component } from 'react'
import { connect } from 'react-redux'
import { Modal } from 'reactstrap'
import PropTypes from 'prop-types'

import { PacoLogsModal } from '../../@paco/compositions'
import { ConnectedHelpTooltip } from '../../@paco/connectors'
import checkPermission from '../../@paco/helpers/permissions/checkPermission'
import trans from '../../@paco/helpers/trans'
import { getEventLogsByEntityUuid } from '../../@paco/redux/eventLogs/eventLogsActions'
import {
    addLeaveOfAbsence,
    approveLeaveOfAbsence,
    declineLeaveOfAbsence,
    deleteLeaveOfAbsence,
    patchLeaveOfAbsence,
} from '../../@paco/redux/leaveOfAbsences/leaveOfAbsencesActions'
import { setError } from '../../@paco/redux/leaveOfAbsences/leaveOfAbsencesReducer'
import { setToast } from '../../@paco/redux/toasts/toastsReducer'
import { ToastType } from '../../@paco/types'

import ButtonAuthenticate from '../../components/ButtonAuthenticate/ButtonAuthenticate'
import NewFilters from '../../components/Filters/Filters'
import DeleteResourceForm from '../../components/forms/DeleteResourceForm/DeleteResourceForm'
import ItemsList from '../../components/ItemsList/ItemsList'
import LeaveOfAbsenceRequestCard from '../../components/LeaveOfAbsenceRequestCard/LeaveOfAbsenceRequestCard'
import SearchBar from '../../components/SearchBar/SearchBar'
import SidebarPage from '../../components/SidebarPage/SidebarPage'
import { LEAVE_OF_ABSENCE_REQUESTS, LEAVE_OF_ABSENCES_REQUEST_OPEN } from '../../constants'
import { getRangeFromDate } from '../../helpers/date'
import { translate } from '../../helpers/translations/translator'
import { LeaveOfAbsenceEditType } from '../../models'
import { getLeaveOfAbsenceRequests } from '../../redux/absences-ts/absencesActions'
import { setEmployeeSearch, setFilter } from '../../redux/filter/filterActions'
import { setStartAndEndDate } from '../../redux/weekNavigator/weekNavigatorActions'
import AddLeaveOfAbsenceForm from './forms/AddLeaveOfAbsenceForm'
import ApproveLeaveOfAbsenceForm from './forms/ApproveLeaveOfAbsenceForm/ApproveLeaveOfAbsenceForm'
import DeclineLeaveOfAbsenceForm from './forms/DeclineLeaveOfAbsenceForm'
import ResolveLeaveOfAbsenceForm from './forms/ResolveLeaveOfAbsenceForm/ResolveLeaveOfAbsenceForm'

import './Absences.scss'

class LeaveOfAbsenceRequests extends Component {
    state = {
        resolveAbsenceForm: false,
        removeForm: false,
        declineForm: false,
        approveForm: false,
        absenceData: null,
        addLeaveOfAbsenceForm: false,
        logsModal: false,
    }

    componentDidMount() {
        this.getLeaveOfAbsences()
    }

    componentDidUpdate(prevProps) {
        const activeDepartmentOptions = this.props.departmentOptions.filter(option => option.isChecked)
        const prevActiveDepartmentOptions = prevProps.departmentOptions.filter(option => option.isChecked)

        if (activeDepartmentOptions.length !== prevActiveDepartmentOptions.length) {
            this.getLeaveOfAbsences()
        }

        if (this.props.leaveOfAbsencesError && this.props.leaveOfAbsencesError !== prevProps.leaveOfAbsencesError) {
            this.props.dispatch(setToast({
                text: this.props.leaveOfAbsencesError,
                type: ToastType.fail,
                shouldFadeOutAutomatically: false,
            }))

            this.props.dispatch(setError(''))
        }
    }

    dispatchRemoveLeaveOfAbsence = async () => {
        this.setState({ removeForm: false })

        await this.props.dispatch(deleteLeaveOfAbsence(this.state.absenceData))

        this.getLeaveOfAbsences()
    }

    dispatchDeclineLeaveOfAbsence = async (declineComment) => {
        this.setState({
            declineForm: false,
            absenceData: null,
        })

        await this.props.dispatch(declineLeaveOfAbsence(this.state.absenceData, declineComment))

        this.getLeaveOfAbsences()
    }

    dispatchApproveLeaveOfAbsence = async (
        payrollPeriodsWithHours,
        weeksWithHours,
        leaveType,
        data,
    ) => {
        this.setState({
            approveForm: false,
            resolveAbsenceForm: false,
            absenceData: null,
        })

        await this.props.dispatch(approveLeaveOfAbsence(
            this.state.absenceData,
            data,
            this.state.absenceData.leaveOfAbsenceHours,
            weeksWithHours,
            leaveType,
        ))

        this.getLeaveOfAbsences()
    }

    dispatchEditLeaveOfAbsence = async (
        data,
        weeksWithHours,
        leaveType,
    ) => {
        this.setState({
            resolveAbsenceForm: false,
            absenceData: null,
        })

        await this.props.dispatch(patchLeaveOfAbsence(
            this.state.absenceData,
            data,
            this.state.absenceData.leaveOfAbsenceHours,
            weeksWithHours,
            leaveType,
        ))

        this.getLeaveOfAbsences()
    }

    dispatchAddLeaveOfAbsence = async (
        userId,
        data,
        weeksWithHours,
        comment,
        leaveType,
    ) => {
        this.setState({
            addLeaveOfAbsenceForm: false,
        })

        await this.props.dispatch(addLeaveOfAbsence(
            userId,
            data,
            weeksWithHours,
            leaveType,
            comment,
        ))

        this.getLeaveOfAbsences()
    }

    dispatchSetDate = (date) => {
        const { timeMode } = this.props
        const days = getRangeFromDate(date, timeMode)
        this.props.dispatch(setStartAndEndDate(days[0], days[0], days[days.length - 1]))
    }

    onSubmitLeaveOfAbsenceForm = (
        editType,
        data,
        payrollPeriodsWithHours,
        weeksWithHours,
        leaveType,
    ) => {
        switch (editType) {
            case LeaveOfAbsenceEditType.deny:
                this.addDeclineLeaveOfAbsenceForm()
                break
            case LeaveOfAbsenceEditType.delete:
                this.setState({
                    removeForm: true,
                    resolveAbsenceForm: false,
                })
                break
            case LeaveOfAbsenceEditType.accept:
                this.dispatchApproveLeaveOfAbsence(
                    payrollPeriodsWithHours,
                    weeksWithHours,
                    leaveType,
                    data,
                )
                break
            default:
                this.dispatchEditLeaveOfAbsence(
                    data,
                    weeksWithHours,
                    leaveType,
                )
                break
        }
    }

    addDeclineLeaveOfAbsenceForm = () => {
        this.setState({
            resolveAbsenceForm: false,
            declineForm: true,
        })
    }

    dispatchOpenLogsModal = (id) => {
        this.props.dispatch(getEventLogsByEntityUuid(id))
        this.setState({
            logsModal: true,
        })
    }

    dispatchCloseLogsModal = () => {
        this.setState({
            logsModal: false,
        })
    }

    dispatchSetFilters = (filter) => {
        this.props.dispatch(setFilter(filter, this.getLeaveOfAbsences))
    }

    onSearchBarChange = (value) => {
        this.props.dispatch(setEmployeeSearch(value))
        this.getLeaveOfAbsences()
    }

    getLeaveOfAbsences = () => {
        this.props.dispatch(getLeaveOfAbsenceRequests(LEAVE_OF_ABSENCE_REQUESTS, LEAVE_OF_ABSENCES_REQUEST_OPEN))
    }

    addLeaveOfAbsence = () => {
        this.setState({
            addLeaveOfAbsenceForm: true,
        })
    }

    renderLeaveOfAbsences() {
        const {
            removeForm,
            declineForm,
            approveForm,
            addLeaveOfAbsenceForm,
            absenceData,
            resolveAbsenceForm,
        } = this.state
        const {
            filter,
            employees,
            openLeaveOfAbsencesRequests,
            loading,
            leaveOfAbsencesLoading,
            pagination,
            permissions,
            payrollPeriods,
            pacoPayrollPeriods,
            eventLogs,
            eventLogsLoading,
            currentUser,
        } = this.props
        const { employeeSearch } = filter

        const existsInLoket = absenceData?.leaveOfAbsenceHours?.some((hours) => hours.loketIds?.length)

        return (
            <>
                <div className="absences-search">
                    <SearchBar placeholder={translate('common.searchEmployee')} startVal={employeeSearch} onChange={this.onSearchBarChange} />
                </div>
                <ItemsList
                    isLoading={loading || leaveOfAbsencesLoading}
                    itemsLength={openLeaveOfAbsencesRequests.length}
                    pagination={pagination}
                    emptyMessage={translate('pages.absences.emptyLeaveOfAbsencesList')}
                    onPagination={this.getLeaveOfAbsences}
                >
                    <div className="leave-of-absence-requests">
                        <ConnectedHelpTooltip
                            index={2}
                            route="leave-of-absence-requests"
                            subTitle={trans('help.absences.leaveOfAbsenceRequestCard.title')}
                            text={trans('help.absences.leaveOfAbsenceRequestCard.text')}
                            title={trans('help.absences.title')}
                            className="absences__leave-of-absence-request-card-help-tooltip"
                        />
                        <ConnectedHelpTooltip
                            index={3}
                            route="leave-of-absence-requests"
                            subTitle={trans('help.absences.seeLeaveOfAbsencesInCalendar.title')}
                            text={trans('help.absences.seeLeaveOfAbsencesInCalendar.text')}
                            title={trans('help.absences.title')}
                            className="absences__see-leave-of-absences-in-calendar-help-tooltip"
                        />
                        {openLeaveOfAbsencesRequests.map(absence => (
                            <LeaveOfAbsenceRequestCard
                                key={absence.id}
                                absence={absence}
                                currentUserRole={currentUser.role}
                                permissions={permissions}
                                payrollPeriods={pacoPayrollPeriods}
                                onApprove={() => this.setState({
                                    approveForm: true, absenceData: absence,
                                })}
                                onDecline={() => this.setState({
                                    declineForm: true, absenceData: absence,
                                })}
                                onOpenCalendar={() => this.dispatchSetDate(absence.start)}
                                onShowLogsClick={() => this.dispatchOpenLogsModal(absence.id)}
                                onEditClick={() => this.setState({
                                    absenceData: absence, resolveAbsenceForm: true,
                                })}
                            />
                        ))}
                    </div>
                </ItemsList>
                <Modal size="lg" isOpen={declineForm} className="form-decline-leave-of-absence">
                    <DeclineLeaveOfAbsenceForm
                        hasPendingChangeset={!!absenceData?.changeset}
                        onSubmit={this.dispatchDeclineLeaveOfAbsence}
                        onCancel={() => this.setState({ declineForm: false, absenceData: null })}
                    />
                </Modal>
                <Modal size="lg" isOpen={removeForm} className="form-decline-leave-of-absence">
                    <DeleteResourceForm
                        title={translate('pages.absences.deleteLeaveOfAbsence')}
                        intro={
                            existsInLoket
                                ? translate('pages.absences.deleteLeaveOfAbsenceWarningWithLoketInfo')
                                : translate('pages.absences.deleteLeaveOfAbsenceWarning')
                        }
                        onSubmit={() => this.dispatchRemoveLeaveOfAbsence(this.state.absenceData)}
                        onCancel={() => this.setState({ removeForm: false, absenceData: null })}
                    />
                </Modal>
                <Modal size="lg" isOpen={approveForm} className="form-approve-leave-of-absence">
                    <ApproveLeaveOfAbsenceForm
                        leaveOfAbsence={absenceData}
                        permissions={permissions}
                        pacoPayrollPeriods={pacoPayrollPeriods}
                        payrollPeriods={payrollPeriods}
                        onSubmit={this.dispatchApproveLeaveOfAbsence}
                        onCancel={() => this.setState({ approveForm: false, absenceData: null })}
                    />
                </Modal>
                <Modal size="lg" isOpen={addLeaveOfAbsenceForm} className="form-add-leave-of-absence">
                    <AddLeaveOfAbsenceForm
                        employees={employees}
                        permissions={permissions}
                        pacoPayrollPeriods={pacoPayrollPeriods}
                        payrollPeriods={payrollPeriods}
                        onSubmit={this.dispatchAddLeaveOfAbsence}
                        onCancel={() => this.setState({ addLeaveOfAbsenceForm: false })}
                    />
                </Modal>
                <Modal size="lg" isOpen={resolveAbsenceForm} className="form-resolve-leave-of-absence">
                    <ResolveLeaveOfAbsenceForm
                        absence={absenceData}
                        currentUserRole={currentUser.role}
                        permissions={permissions}
                        pacoPayrollPeriods={pacoPayrollPeriods}
                        payrollPeriods={payrollPeriods}
                        onSubmit={this.onSubmitLeaveOfAbsenceForm}
                        onCancel={() => this.setState({ resolveAbsenceForm: false })}
                        onShowLogsClick={() => this.dispatchOpenLogsModal(absenceData.id)}
                    />
                </Modal>
                <PacoLogsModal
                    isLoading={eventLogsLoading}
                    isOpen={this.state.logsModal && ! eventLogsLoading}
                    title={translate('logs.leaveOfAbsenceLog')}
                    emptyMessage={translate('logs.emptyLeaveOfAbsenceLog')}
                    logs={eventLogs}
                    onClose={this.dispatchCloseLogsModal}
                />
            </>
        )
    }

    render() {
        const {
            departments,
            filter,
            permissions,
            roles,
            employmentTypes,
        } = this.props
        const canAddLeaveOfAbsence = checkPermission(permissions, 'add-new-leave-of-absences')
            || checkPermission(permissions, 'add-new-employee-leave-of-absences')
            || checkPermission(permissions, 'add-new-manager-leave-of-absences')
            || checkPermission(permissions, 'add-new-junior-manager-leave-of-absences')

        return (
            <>
                <SidebarPage
                    sidebarContent={(
                        <NewFilters
                            departments={departments}
                            filter={filter}
                            roles={roles}
                            employmentTypes={employmentTypes}
                            button={
                                canAddLeaveOfAbsence ? (
                                    <ButtonAuthenticate onClick={this.addLeaveOfAbsence} text={translate('pages.absences.addLeaveOfAbsence')} />
                                ) : null
                            }
                            filterBlocks={[
                                'user-types',
                                'contract-types',
                                'main-department',
                            ]}
                            onChange={this.dispatchSetFilters}
                        />
                    )}
                >
                    <div className="absences-list">
                        {this.renderLeaveOfAbsences()}
                    </div>
                    <ConnectedHelpTooltip
                        index={0}
                        route="leave-of-absence-requests"
                        subTitle={trans('help.absences.addLeaveOfAbsence.title')}
                        text={trans('help.absences.addLeaveOfAbsence.text')}
                        title={trans('help.absences.title')}
                        className="absences__add-leave-of-absence-help-tooltip"
                    />
                    <ConnectedHelpTooltip
                        index={1}
                        route="leave-of-absence-requests"
                        subTitle={trans('help.absences.leaveOfAbsencesFilters.title')}
                        text={trans('help.absences.leaveOfAbsencesFilters.text')}
                        title={trans('help.absences.title')}
                        showMobileInfoWarning
                        className="absences__filters-help-tooltip"
                    />
                </SidebarPage>
                <ButtonAuthenticate
                    onClick={this.addLeaveOfAbsence}
                    mobile
                />
            </>
        )
    }
}

LeaveOfAbsenceRequests.propTypes = {
    loading: PropTypes.bool.isRequired,
    leaveOfAbsencesLoading: PropTypes.bool.isRequired,
    leaveOfAbsencesError: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    departments: PropTypes.array.isRequired,
    departmentOptions: PropTypes.array.isRequired,
    employmentTypes: PropTypes.array.isRequired,
    payrollPeriods: PropTypes.array.isRequired,
    pacoPayrollPeriods: PropTypes.array.isRequired,
    currentUser: PropTypes.object.isRequired,
    openLeaveOfAbsencesRequests: PropTypes.array.isRequired,
    filter: PropTypes.object.isRequired,
    employees: PropTypes.array.isRequired,
    timeMode: PropTypes.string.isRequired,
    pagination: PropTypes.object.isRequired,
    permissions: PropTypes.array.isRequired,
    roles: PropTypes.array.isRequired,
    eventLogs: PropTypes.array,
    eventLogsLoading: PropTypes.bool.isRequired,
}

export default connect()(LeaveOfAbsenceRequests)
